import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import { useLang } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

// Envelopje in de topbar: aantal onbeantwoorde mails in de gedeelde receptie-mailbox.
export default function MailBell() {
  const { t } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [count, setCount] = React.useState(0);
  const allowed = ["admin", "superadmin"].includes(user?.role) || user?.mailbox_access;

  React.useEffect(() => {
    if (!allowed) return undefined;
    const tick = () => api.get("/mailbox/unread").then(({ data }) => setCount(data.unseen || 0)).catch(() => {});
    tick();
    const id = setInterval(tick, 60000);
    return () => clearInterval(id);
  }, [allowed, location.pathname]);

  if (!allowed) return null;
  return (
    <button onClick={() => navigate("/mailbox")} data-testid="mail-bell" title={t("mb_unread")}
      className="relative grid h-8 w-8 sm:h-9 sm:w-9 place-items-center rounded-full border border-border bg-muted/70 text-muted-foreground transition-transform hover:scale-105 active:scale-95 hover:text-foreground">
      <Mail className="h-4 w-4" />
      {count > 0 && (
        <span data-testid="mail-bell-count"
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 grid place-items-center rounded-full bg-rose-600 text-white text-[10px] font-bold tabular-nums">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
